import { Store } from '@ngxs/store';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '@shared/providers/http.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SignatureService extends HttpService {
  constructor(private httpClient: HttpClient, private store: Store) {
    super(environment.endpoints.contestation, httpClient, store);
  }

  async create(body) {
    return await this.postAsync(body);
  }
}
